import { render, staticRenderFns } from "./FileSet.vue?vue&type=template&id=3677cddb&scoped=true&"
import script from "./FileSet.vue?vue&type=script&lang=js&"
export * from "./FileSet.vue?vue&type=script&lang=js&"
import style0 from "./FileSet.vue?vue&type=style&index=0&id=3677cddb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3677cddb",
  null
  
)

export default component.exports